import { Grid } from '@chakra-ui/react';
import { LogoIcon } from 'assets/common/LogoIcon';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon } from 'assets/icons/v2';

type Props = {
  onBackClick?: () => void;
};

export const TopBarTertiary = ({ onBackClick }: Props): ReactElement => {
  const navigate = useNavigate();
  return (
    <Grid
      placeItems="center"
      position="relative"
      width="100%"
      bg="background.primary"
      boxShadow="0px 0px 4px rgba(0, 0, 0, 0.1)"
      height="60px"
    >
      <NovaIconButton
        aria-label="Zurück"
        position="absolute"
        left="0"
        top="50%"
        transform="translateY(-50%)"
        variant="primary"
        size="l"
        ml="10px"
        onClick={() => (onBackClick === undefined ? navigate(-1) : onBackClick())}
        icon={ChevronLeftIcon}
        iconProps={{ color: 'icon.secondary' }}
      />
      <LogoIcon w="33px" h="33px" />
    </Grid>
  );
};
